import classNames from 'classnames';
import { FC, PropsWithChildren, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type SpModalProps = Readonly<{
  size?: 'lg' | 'xl' | 'sm';
  isOpened: boolean;
  toggleOpen: () => void;
}>;

export const SpModal: FC<PropsWithChildren<SpModalProps>> = ({ children, isOpened, toggleOpen, size }) => {
  const modalRoot = document.getElementById('modal-root')!;
  const [show, setShow] = useState(false);
  const [present, setPresent] = useState(false);
  const sizeClass = size !== undefined ? `modal-${size}` : null;

  useLayoutEffect(() => {
    if (isOpened) {
      setPresent(true);
      const timerId = setTimeout(() => {
        setShow(true);
      }, 100);
      return () => clearTimeout(timerId);
    } else {
      setShow(false);
      const timerId = setTimeout(() => {
        setPresent(false);
      }, 1000);
      return () => clearTimeout(timerId);
    }
  }, [isOpened]);

  if (!present) {
    return null;
  }

  return createPortal(
    <>
      <div
        className={classNames('modal fade', { show })}
        aria-modal={isOpened}
        aria-hidden={!isOpened}
        role={isOpened ? 'dialog' : undefined}
        tabIndex={-1}
        style={{ display: 'block' }}
        onClick={toggleOpen}
      >
        <div className={classNames('modal-dialog', sizeClass)} role="document">
          {children}
        </div>
      </div>
      <div className={classNames('modal-backdrop fade', { show })}></div>
    </>,
    modalRoot,
  );
};
